module.exports = __webpack_public_path__ + "static/media/cert_123.0bbf217a.jpg";